var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box p-4 has-background-white mb-0" }, [
    _c("nav", { staticClass: "level is-mobile" }, [
      _c("div", { staticClass: "level-left" }, [
        _vm.estado != "pendiente" ||
        (_vm.estado === "pendiente" &&
          _vm.$store.getters.hasAnyRole(["empleador"]))
          ? _c("div", { staticClass: "level-item" }, [
              _c(
                "a",
                {
                  staticClass: "button is-primary",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("descargar", "recibo")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fas fa-download" }),
                  _vm._v(" Descargar recibo\r\n      "),
                ]
              ),
            ])
          : _c("div", { staticClass: "level-item" }, [
              _c(
                "a",
                {
                  staticClass: "button is-primary",
                  attrs: {
                    title:
                      "Atención: no se descarga un recibo, se descarga una liquidación para control",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("descargar", "recibo")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fas fa-download" }),
                  _vm._v(" Descargar liquidación\r\n      "),
                ]
              ),
            ]),
        _vm._v(" "),
        _c("div", { staticClass: "level-item" }, [
          _c(
            "a",
            {
              staticClass: "button is-light is-hidden-touch",
              on: {
                click: function ($event) {
                  return _vm.$emit("preview")
                },
              },
            },
            [
              _c("i", { staticClass: "fas fa-glasses fa-fw" }),
              _vm._v(
                " Ver\r\n        " +
                  _vm._s(
                    _vm.estado != "pendiente" ||
                      (_vm.estado === "pendiente" &&
                        _vm.$store.getters.hasAnyRole(["empleador"]))
                      ? " Recibo"
                      : " Liquidación"
                  )
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "level-item" }, [
          _c(
            "a",
            {
              staticClass: "button is-light is-hidden-touch",
              on: {
                click: function ($event) {
                  return _vm.$emit("print")
                },
              },
            },
            [
              _c("i", { staticClass: "fas fa-print fa-fw" }),
              _vm._v(" Imprimir"),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "level-item" }, [
          _c(
            "a",
            {
              staticClass: "button is-light",
              on: {
                click: function ($event) {
                  return _vm.$emit("refresh")
                },
              },
            },
            [_c("i", { staticClass: "fas fa-sync fa-fw" }), _vm._v(" Recargar")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.$store.getters.hasAnyRole(["empleador"]) && _vm.estado == "pendiente"
        ? _c("div", { staticClass: "level-right" }, [
            _c(
              "div",
              { staticClass: "level-item" },
              [
                _c(
                  "b-dropdown",
                  {
                    attrs: { "aria-role": "list", position: "is-bottom-left" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "trigger",
                          fn: function ({ active }) {
                            return _c(
                              "button",
                              { staticClass: "button is-light" },
                              [
                                _vm._v("\r\n            Otras acciones "),
                                _c("i", {
                                  staticClass: "fas fa-fw",
                                  class: active
                                    ? "fa-chevron-up"
                                    : "fa-chevron-down",
                                }),
                              ]
                            )
                          },
                        },
                      ],
                      null,
                      false,
                      2429813874
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "b-dropdown-item",
                      {
                        attrs: { "aria-role": "listitem" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("preview")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fas fa-glasses fa-fw" }),
                        _vm._v(" Ver"),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.$store.getters.hasAnyRole(["empleador"]) &&
                    _vm.estado == "pendiente"
                      ? _c(
                          "b-dropdown-item",
                          {
                            staticClass: "has-text-danger",
                            attrs: { "aria-role": "listitem" },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("eliminar")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fas fa-trash fa-fw" }),
                            _vm._v(" Eliminar"),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }